<template>
  <div class="page zntjMd" v-loading='waiting'>
    <div class="page-header">
      <div class="page-title"><span class="back" @click="goList"><img src="@/assets/subscribe/back.svg">返回</span><span class="txt">最多可订阅 <i style="color:#5088FF;font-size:13px">5</i> 组 ，剩余 <i
            style="color:#5088FF;font-size:13px">{{subscribieInfo.length?(5-subscribieInfo.length):5}}</i> 组可用</span></div>
      <div class="page-header-action">
        <el-button @click="addSubscribe('add')" type="dialog-confirm" size="small">新增订阅</el-button>
      </div>
    </div>
    <div class="intelBox">
      <div class="table-header">
        <el-row>
          <el-col :span="9">
            <span class="sp1">商机订阅名称</span>
          </el-col>
          <el-col :span="6">
            <span class="sp2">偏好</span>
          </el-col>
          <el-col :span="6">
            <span class="sp3">推送设置</span>
          </el-col>
          <el-col :span="3">
            <span class="sp4">操作</span>
          </el-col>
        </el-row>
      </div>
      <div class="detail">
        <div v-show="subscribieInfo.length" class="subscribe-item clearfix" v-for="(item,index) in subscribieInfo" :key='index'>
          <div class="info-box">
            <el-row>
              <el-col :span="9">
                <!-- <div class="logoAndStar clearfix">
                                      <div class="logo"><img src="" alt="" srcset=""></div>
                                </div> -->
                <div class="company-info company-info1">
                  <p class="company-title">{{item.subscriptionName}}</p>
                  <div class="cmTg">
                    <span :class="item.status == 1?'enable-status':'stop-status'">{{item.status == 1 ?'已启用':'已停用'}}</span>
                    <span>{{subscribieTypeTag[item.subscriptionType]}}</span>
                  </div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="company-info company-info2">
                  <p><span class="name">地区:</span>{{item.regionNameList?item.regionNameList.toString():'全部'}}</p>
                  <p><span class="name">行业:</span>{{item.industryNameList?item.industryNameList.toString():'全部'}}</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="company-info company-info2">
                  <p><span class="name">推送周期:</span>{{dateType[item.dateType]}}{{item.dateType == 2?weeks[item.week]:''}} {{item.hourTime}}</p>
                  <p><span class="name">推送方式:</span>{{pushType[item.pushType]}}</p>
                  <p class="push-way"><span class="name" style="opacity: 0;">推送方式:</span><el-button type="text" @click="editPush(item,'c','edit')">修改推送</el-button></p>
                </div>
              </el-col>
              <el-col :span="3">
                <div class="company-info company-info2" style="margin-top:8px">
                  <el-button type="text" v-if="item.status == 1" @click="getSubscribeStatus(item,2)">停用</el-button>
                  <el-button type="text" v-if="item.status == 2" @click="getSubscribeStatus(item,1)">启用</el-button>
                  <el-button type="text" @click="editPush(item,'a','edit')">编辑</el-button>
                  <el-button type="text" @click="delSubscribe(item,3)">删除</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="empty" v-show="!subscribieInfo.length">
          <!-- <img src="@/assets/subscribe/empty.png"> -->
          <div class="empty-ordinary">
            <img src="@/assets/newicons/i002.png" alt="" srcset="">
            <p class="center">暂无数据</p>
          </div>
        </div>
      </div>
    </div>
    <!-- <pagination :pageNum="list.pageNum" :pageSize="list.pageSize" :total="list.total" @sizeChange="handleSizeChange" @currentChange="handleCurrentChange" :key="list.pageNum" /> -->
    <robot />
    <subscribe-drawer ref="subscribeDrawer"></subscribe-drawer>
    <!-- <subscribe-info-push ref="subscribeInfoPush"></subscribe-info-push> -->
    <right-float ref="rightFloat" :globalRfType="true"></right-float>
  </div>
</template>

<script>
import pagination from '@/components/pagination/'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import Robot from '../components/robot'
import { subscribeStatus, subscribeManagement } from '@/views/clue/api/subscribeApi'
import subscribeDrawer from '@/components/subscribeDrawer'
// import subscribeInfoPush from '@/components/subscribeInfoPush'
import RightFloat from '@/components/rightFloatBtn'
export default {
  name: 'subscribeManagement',
  components: {
    Robot,
    pagination,
    subscribeDrawer,
    // subscribeInfoPush,
    RightFloat
  },
  data() {
    return {
      waiting: false,
      list: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        tab: 1,
        tableData: []
      },
      subscribieInfo: [],
      subscribieTypeTag: { 1: '最近成立的企业', 2: '最近有新网站的企业' },//订阅类型
      pushType: { 1: '浏览器推送', 2: '企微推送' },//推送类型
      dateType: { 1: '每天', 2: '每周' },//推送周期类型
      weeks: { 1: '一', 2: '二', 3: '三', 4: '四', 5: '五', 6: '六', 7: '日' }
    }
  },
  computed: {
    ...mapState({
      staffInfo: state => state.user.staffInfo
    }),
  },
  watch: {
  },
  mounted() {
    this.getSubscribeManagement()
  },
  methods: {
    goList() {
      this.$router.push('/zxk/junbros/subscribeList')
    },
    // 订阅管理列表
    getSubscribeManagement() {
      this.waiting = true
      subscribeManagement().then(res => {
        if (res.code == 200) {
          this.waiting = false
          this.subscribieInfo = res.data
          // this.$refs.subscribeInfoPush.getSubscribeManagement()
        }
      }).catch(err => {
        this.waiting = false
      })
    },
    // 删除/启用、停用
    getSubscribeStatus(v, num) {
      v.status = num
      subscribeStatus({ id: v.id, status: num }).then(res => {
        if (res.code == 200) {
          if (num == 2) {
            this.$message.warning('该订阅组已停用，次日将不在新增商机')
          }
          this.getSubscribeManagement()
        }
      })
    },
    handleSizeChange(val) {
      console.log('lll')
    },
    handleCurrentChange(val) {
    },
    // 删除订阅
    delSubscribe(v, num) {
      const confirmText = ['是否删除该订阅？', '点击确定按钮删除，该订阅将不可恢复']
      const newDatas = []
      const h = this.$createElement
      for (const i in confirmText) {
        newDatas.push(h('p', null, confirmText[i]))
      }
      this.$confirm(
        '提示',
        {
          title: '提示',
          message: h('div', null, newDatas),
          showCancelButton: true,
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning',
          customClass: 'delsubscribe'
        }
      ).then(() => {
        this.getSubscribeStatus(v, num)
      }).catch(action => {

      })
    },
    removeHtml(str) {
      if (!str) return
      const reTag = /<(?:.|\s)*?>/g
      return str.replace(reTag, '').replace(/&nbsp;/ig, '')
    },
    // 新增订阅
    addSubscribe(type) {
      // 是否是演示账号
      if (this.staffInfo.demonstrationTag == 1) {
        this.$message({
          message: '演示账号，无法使用此功能',
          type: 'error'
        });
        return false
      }
      if (this.subscribieInfo.length == 5) {
        this.$message({
          message: '每个租户最多可订阅5组商机订阅',
          type: 'warning'
        });
        return false
      }
      this.$refs.subscribeDrawer.openDrawer()
      this.$refs.subscribeDrawer.createdName(type)
    },
    editPush(item, step, type) {
      if (item.status == 2) {
        this.$message.warning('请启用后编辑订阅')
        return false
      }
      this.$refs.subscribeDrawer.getSubscribeDetail(item.id, step, type)
      this.$refs.subscribeDrawer.openDrawer()
    },

  }
}
</script>

<style lang="scss" scoped>
.page {
  margin: 0 auto;
  // width: 1100px;
}

.page-header {
  display: flex;
  padding: 0 24px;
  align-items: center;
  background: #fafafd;
  border-radius: 4px 4px 0px 0px;
  height: 51px;
  .page-title {
    font-size: 16px;
    color: #343951;
    font-weight: bold;
    width: 100%;
    span.txt {
      // font-size: 16px;
      position: relative;
      padding-left: 16px;
      margin-left: 16px;
      box-sizing: border-box;
      &::before {
        display: block;
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        width: 2px;
        height: 16px;
        background: #bbbeca;
      }
    }
    .back {
      cursor: pointer;
      img {
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
    }
  }
  &-action {
    margin-left: auto;
    display: flex;
    align-items: center;
    i {
      cursor: pointer;
      font-size: 18px;
      margin-right: 12px;
      color: #409eff;
    }
  }
}
.detail {
  padding: 0;
}
.intelBox {
  background-color: white;
  margin-top: 16px;
  margin-bottom: 24px;
  box-shadow: 0px 1px 5px 0px rgba(38, 38, 38, 0.1);
  .table-header {
    color: #333333;
    background: rgb(250, 250, 250);
    line-height: 50px;
    padding: 0 24px;
    box-sizing: border-box;
    .el-row {
      span {
        font-weight: bold;
        color: #333333;
        font-size: 14px;
      }
    }
  }
}

@keyframes changeRotate {
  0% {
    transform: rotateZ(0deg);
    -ms-transform: rotateZ(0deg);
    -moz-transform: rotateZ(0deg);
    -webkit-transform: rotateZ(0deg);
    -o-transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
    -ms-transform: rotateZ(360deg);
    -moz-transform: rotateZ(360deg);
    -webkit-transform: rotateZ(360deg);
    -o-transform: rotateZ(360deg);
  }
}
.page-header {
  .page-header-action {
    .el-button--dialog-confirm {
      width: 100px;
      height: 36px;
      padding: 0;
    }
  }
}
.zntjMd {
  .setCheckBox {
    text-align: center;
    height: 72px;
    background: rgba(187, 190, 202, 0.3);
    line-height: 72px;
    border-bottom: none;
  }
}

.subscribe-item {
  border-bottom: 1px solid #f1f1f2;
  position: relative;
  padding: 24px;
  box-sizing: border-box;
  .logoAndStar {
    width: 58px;
    height: 58px;
    float: left;
    margin-right: 24px;
    background: #5088ff;
    .logo2 {
      float: left;
      width: 58px;
      height: 58px;
      padding: 6px;
      background-color: royalblue;
      font-weight: 400;
      color: #fff;
      text-align: center;
      font-size: 18px;
      line-height: 48px;
      border-radius: 2px;
      margin-right: 10px;
    }
  }
  .info-box {
    // width: calc(100% - 82px);
    width: 100%;
    .company-info {
      padding-right: 15px;
      box-sizing: border-box;
      .company-title {
        font-weight: bold;
        color: #333333;
        line-height: 22px;
        height: 22px;
        font-size: 16px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        padding-right: 30px;
        box-sizing: border-box;
      }
      p {
        color: #333333;
        font-size: 13px;
        //  margin-bottom: 8px;
        margin-bottom: 10px;
        .name {
          font-weight: 400;
          color: rgba(51, 51, 51, 0.5);
          margin-right: 4px;
        }
        &.push-way {
          margin-top: -6px;
          margin-bottom: 0px;
          .el-button--text {
            padding: 0;
          }
        }
      }
      .cmTg {
        span {
          background: rgba(80, 136, 255, 0.15);
          border-radius: 2px;
          padding: 5px 8px;
          box-sizing: border-box;
          font-weight: 400;
          color: #5088ff;
          font-size: 12px;
          margin-right: 8px;
          &.stop-tag {
            background: rgba(244, 102, 74, 0.15);
            color: #f4664a;
          }
          &.stop-status {
            background: rgba(244, 102, 74, 0.15);
            color: #f4664a;
            padding: 5px 8px;
          }
          &.enable-status {
            background: rgba(48, 191, 120, 0.15);
            color: #30bf78;
            padding: 5px 8px;
          }
        }
      }
    }
  }
}
.empty {
  padding: 100px;
  box-sizing: border-box;
  img {
    display: block;
    margin: auto;
    width: 150px;
    margin-bottom: -20px;
  }
  p {
    color: #999999;
    text-align: center;
  }
}
::v-deep {
}
</style>
<style  lang="scss">
.delsubscribe {
  width: 350px;
  min-width: auto;
  border-radius: 4px;
  padding-bottom: 0 !important;
  .el-button {
    width: 88px;
    padding-top: 0;
    padding-bottom: 0;
    line-height: 32px;
    height: 32px;
  }
  .el-message-box__header {
    background: #fbfbfb;
    padding: 0 18px 0 24px;
    box-sizing: border-box;
    .el-message-box__title {
      height: 42px;
      line-height: 42px;
      font-weight: 600;
      color: #666666;
      font-size: 14px;
    }
    .el-message-box__headerbtn {
      top: 10px;
      .el-message-box__close,
      .el-icon-close:before {
        width: 20px;
        height: 20px;
        font-size: 20px;
      }
    }
  }
  .el-message-box__content {
    padding: 24px 24px 24px;
    box-sizing: border-box;
    .el-message-box__message {
      p {
        font-weight: 400;
        color: #333333;
        line-height: 20px;
        font-size: 14px;
        &:nth-of-type(1) {
          font-weight: bold;
          color: #333333;
          font-size: 16px;
          margin-bottom: 4px;
        }
      }
    }
    .el-message-box__input {
      padding-top: 8px;
      padding-bottom: 18px;
    }
  }
  .el-message-box__btns {
    text-align: center;
    height: 56px;
    line-height: 56px;
    background: #fafafa;
    padding: 0;
    button:nth-child(2) {
      margin-left: 30px;
    }
  }
  .el-message-box__errormsg {
    margin-top: 4px;
  }
  .el-message-box__status {
    position: relative;
    display: block;
    margin: auto;
    text-align: center;
    top: 16px;
    background: url(~@/assets/gbIcon/warning_icon.png) no-repeat center;
    width: 50px;
    height: 50px;
    &::before {
      display: none;
    }
  }
  .el-message-box__status + .el-message-box__message {
    padding: 0;
    text-align: center;
  }
}
</style>